import { LitElement, html, nothing } from "lit";
import { property, customElement } from "lit/decorators.js";
import { findIndex, isValidUrl } from "../utils";

@customElement("footer-links")
export class FooterLinks extends LitElement {
  @property()
  links = [];

  @property()
  categories = [];

  @property()
  appLinks: any = [];

  @property()
  theme = "white";

  @property()
  isLoggedIn = false;

  @property()
  partner = null;

  private renderLinks = (link: any) => {
    if (!link || link.length < 1) return;
    return html`
      <a
        class="twf-block twf-mb-4 twf-font-extrabold twf-text-sm twf-font-coco ${this
          .theme === "purple"
          ? "twf-text-white"
          : "twf-text-[#282828]"}"
        >${link.title}</a
      >
      ${link?.links.map((links: any) => {
        if (links.label === "Cashrewards Max" && !this.isLoggedIn) return;
        return html`<a
          class="twf-block twf-mb-3 twf-font-nunito twf-w-fit twf-text-sm ${this
            .theme === "purple"
            ? "hover:twf-text-[#C4FF2F] twf-text-white"
            : "hover:twf-text-cr-purple-500 twf-text-[#282828]"}"
          href="${isValidUrl(links.href)}"
          rel="${links.rel|| nothing}"
          target="${links.target || nothing}"
        >
          ${links.label}</a
        > `;
      })}
    `;
  };

  private renderCategoryLinks = (links: any) => {
    if (!links || links.length < 1) return;
    return html`
      ${links.map((link: any) => {
        return html`<a
          class="twf-block twf-mb-3 twf-font-nunito twf-w-fit twf-text-sm ${this
            .theme === "purple"
            ? "hover:twf-text-[#C4FF2F] twf-text-white"
            : "hover:twf-text-cr-purple-500 twf-text-[#282828]"}"
          href="/category/${link.HyphenatedString}"
        >
          ${link.Name}</a
        > `;
      })}
    `;
  };

  private adminSection = (links: any) => {
    return html`
      <div
        id="footer-explore"
        class="twf-grid twf-grid-cols-2 lg:twf-grid-cols-1 twf-gap-x-8 2xl:twf-col-span-3"
      >
        <nav>
          ${this.renderLinks(links[findIndex(links, "About")])}
          <div class="twf-mt-10">
            ${this.renderLinks(
              links[findIndex(links, "Cashrewards for Business")]
            )}
          </div>
        </nav>
        <nav class="lg:twf-hidden">
          ${this.renderLinks(links[findIndex(links, "Help")])}
          <div class="twf-mt-10">
            ${this.renderLinks(links[findIndex(links, "My Account")])}
          </div>
        </nav>
      </div>
      <nav class="twf-hidden lg:twf-block 2xl:twf-col-span-3">
        ${this.renderLinks(links[findIndex(links, "Help")])}
        <div class="twf-mt-10">
          ${this.renderLinks(links[findIndex(links, "My Account")])}
        </div>
        <div class="twf-mt-10">
          ${this.renderLinks(links[findIndex(links, "Seasonal Sales")])}
        </div>
      </nav>
    `;
  };

  private discoverySection = (links: any) => {
    return html`
      <div
        class="twf-grid twf-gap-x-8 twf-grid-cols-2 lg:twf-grid-cols-1 2xl:twf-col-span-3"
      >
        <nav>
          ${this.renderLinks(links[findIndex(links, "Shop")])}
          <div class="twf-mt-10 lg:twf-hidden">
            ${this.renderLinks(links[findIndex(links, "Seasonal Sales")])}
          </div>
          <div class="twf-hidden lg:twf-block lg:twf-mt-10">
            ${this.renderLinks(links[findIndex(links, "Popular Stores")])}
          </div>
        </nav>
        <nav class="lg:twf-hidden">
          ${this.renderLinks(links[findIndex(links, "Popular Stores")])}
        </nav>
      </div>
    `;
  };

  private categorySection = (categories: any) => {
    return html`<ul class="2xl:twf-col-span-3">
      <a
        class="twf-block twf-mb-4 twf-font-extrabold twf-font-coco twf-text-sm ${this
          .theme === "purple"
          ? "twf-text-white"
          : "twf-text-[#282828]"}"
        >Categories</a
      >
      <div class="twf-grid twf-gap-x-8 twf-grid-cols-2 lg:twf-grid-cols-1">
        ${this.renderCategoryLinks(categories)}
      </div>
    </ul>`;
  };

  private divideLine() {
    return html`
      <div
        class="twf-h-[1px] twf-w-full ${this.theme === "purple"
          ? "twf-bg-[#AD5DFC]"
          : "twf-bg-[#BDBDBD]"} twf-mt-8 twf-mb-8 lg:twf-hidden"
      ></div>
    `;
  }

  private fetchBrowserNotifier() {
    let link;
    const userAgent = navigator.userAgent;

    switch (true) {
      case /\bFirefox\b/.test(userAgent):
        link = 4;
        break;
      case /\bChrome\b/.test(userAgent):
        link = 2;
        break;
      case /\bSafari\b/.test(userAgent):
        link = 3;
        break;
      default:
        link = 5;
        break;
    }

    return html`
      <a target="_blank" href=${this.appLinks[link]?.link.href}>
        <img src=${this.appLinks[link]?.image.data.attributes.url} />
      </a>
    `;
  }

  private ctaBrowserExtension = () => {
    return html`
      <div
        class="twf-hidden lg:twf-block lg:twf-w-full xl:twf-mr-0 twf-py-6 twf-px-4 ${this
          .theme === "purple"
          ? "twf-bg-cr-purple-500"
          : "twf-bg-[#F7F7F7] "} twf-rounded-md xl:twf-mb-8"
      >
        <p
          class="twf-font-coco twf-font-extrabold twf-text-lg ${this.theme ===
          "purple"
            ? "twf-text-white"
            : "twf-text-[#282828]"} lg:twf-mb-6"
        >
          Don't miss a deal with the Notifier
        </p>
        ${this.fetchBrowserNotifier()}
      </div>
    `;
  };

  private ctaAppButtons = () => {
    return html`
      <div
        class="twf-w-full twf-py-6 twf-px-4 ${this.theme === "purple"
          ? "twf-bg-cr-purple-500"
          : "twf-bg-[#F7F7F7]"} twf-rounded-md"
      >
        <p
          class="twf-font-coco twf-font-extrabold twf-text-lg ${this.theme ===
          "purple"
            ? "twf-text-white"
            : "twf-text-[#282828]"} twf-mb-6"
        >
          Earn more on the go
        </p>
        <div class="twf-flex">
          <a target="_blank" href=${this.appLinks[1]?.link.href}>
            <img
              class="twf-mr-2"
              src=${this.appLinks[1]?.image.data.attributes.url}
            />
          </a>
          <a target="_blank" href=${this.appLinks[0]?.link.href}>
            <img src=${this.appLinks[0]?.image.data.attributes.url} />
          </a>
        </div>
      </div>
    `;
  };

  override createRenderRoot() {
    return this;
  }

  override render() {
    return html` <div
        id="footer-app-links-sm-md"
        class="${this.partner ? 'twf-hidden': 'twf-px-4 md:twf-px-6 twf-py-8 md:twf-grid md:twf-grid-cols-2 md:twf-gap-x-8 xl:twf-px-8 xl:twf-hidden'}"
      >
        ${this.ctaBrowserExtension()} ${this.ctaAppButtons()}
      </div>
      <div
        class="twf-px-4 twf-pt-8 md:twf-px-6 md:twf-grid lg:twf-grid-cols-4 lg:twf-gap-x-8 xl:twf-px-8 xl:twf-grid-cols-6 2xl:twf-grid-cols-16"
      >
        ${this.adminSection(this.links)} ${this.divideLine()}
        ${this.discoverySection(this.links)} ${this.divideLine()}
        ${this.categorySection(this.categories)} ${this.divideLine()}
        <div
          class="twf-hidden xl:twf-col-span-2 xl:twf-block 2xl:twf-col-span-4"
        >
          ${this.ctaBrowserExtension()} ${this.ctaAppButtons()}
        </div>
      </div>`;
  }
}